import type { Ref } from 'react';
import type { DataGridMAIQRef } from 'app/components/ReusableUIComponents/HighLevelComponents/DataGridMAIQ';

export type HilSegmentAttentionCellClickHandler = (
  params: { row?: unknown },
  clickedElement?: string,
) => void;

export type HilSegmentAttentionActionsBridge = {
  dataGridRef: Ref<DataGridMAIQRef>;
  handleCellClick: HilSegmentAttentionCellClickHandler;
  openRetryAllConfirm: () => void;
};

export function createEmptyHilSegmentAttentionActionsBridge(): HilSegmentAttentionActionsBridge {
  return {
    dataGridRef: { current: null },
    handleCellClick: () => {},
    openRetryAllConfirm: () => {},
  };
}
